import React from 'react';
import "./style.css"

export default function Loader({ small, style }){
    return (
        <svg style={{...style}} className="spinner" width={small ? "25px" : "50px"} height={small ? "25px" : "50px"} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle className="circle" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
    )
}